import { faAngleDown, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faChevronsLeft, faChevronsRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import React from "react";
import { Button } from "userful-chronos-common-ui/dist/elements";

export interface IPagination {
    dataPerPage: number;
    pages: number;
    currentPage: number;
}

interface IProps {
    data: any[];
    pagination: IPagination;
    paginationOptions: number[];
    replace?: React.ReactNode;
    onRowClick?(id: string): void;
    stretch?: boolean; // Stretch the width
    draggable?: boolean; // Allows dragging
    nonInteractive?: boolean; // Do not allow interaction with the row
    sorting?: boolean; // Add sorting
    multiSelect?: boolean; // Allow to multiselect
    onPaginationUpdate(pagination: IPagination): void;
}

export default function UserfulTablePagination(props: IProps) {
    const [rendered, setRendered] = useState<boolean>(false);

    const handleIncreasePage = () => {
        let currentPage = props.pagination.currentPage + 1;
        if (currentPage > props.pagination.pages) currentPage = props.pagination.pages;

        props.onPaginationUpdate({ ...props.pagination, currentPage: currentPage });
    };
    const handleDecreasePage = () => {
        let currentPage = props.pagination.currentPage - 1;
        if (currentPage <= 0) currentPage = 1;

        props.onPaginationUpdate({ ...props.pagination, currentPage: currentPage });
    };
    const handleDataPerPageChange = (num: number) => {
        const dataPerPage = num;
        const pages = Math.ceil(props.data.length / dataPerPage);
        const currentPage = 1;

        props.onPaginationUpdate({
            dataPerPage: dataPerPage,
            pages: pages,
            currentPage: currentPage,
        });
    };
    const insertDropdown = () => {
        return (
            <Dropdown className="operationCenterDropdown">
                <Dropdown.Toggle bsPrefix="pagination-dropdown" as={Button}>
                    {props.pagination.dataPerPage} per Page
                    <FontAwesomeIcon icon={faAngleDown} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdownMenuSwitchActiveSource">
                    {props.paginationOptions?.map((option, index) => {
                        return (
                            <Dropdown.Item
                                key={index}
                                className="dropdownItem"
                                onClick={() => handleDataPerPageChange(option)}
                            >
                                <div className="textInside">{option} per Page</div>
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    const insertPages = () => {
        return (
            <div className="common-userful-exclusive-table-pages noselect">
                <Button
                    iconOnly
                    disabled={props.pagination.currentPage === 1}
                    variant="secondary"
                    onClick={(e) => props.onPaginationUpdate({ ...props.pagination, currentPage: 1 })}
                >
                    <FontAwesomeIcon icon={faChevronsLeft} />
                </Button>
                <Button
                    iconOnly
                    disabled={props.pagination.currentPage - 1 <= 0}
                    variant="secondary"
                    onClick={(e) => handleDecreasePage()}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </Button>
                <div className="pagination-indicator">
                    <p className="pagination-indicator-main">{props.pagination.currentPage}</p>
                    <p className="pagination-indicator-secondary">/{props.pagination.pages}</p>
                </div>
                <Button
                    iconOnly
                    disabled={props.pagination.currentPage + 1 > props.pagination.pages}
                    variant="secondary"
                    onClick={(e) => handleIncreasePage()}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </Button>
                <Button
                    iconOnly
                    disabled={
                        props.pagination.currentPage === props.pagination.pages ||
                        props.pagination.currentPage === props.pagination.pages + 1
                    }
                    variant="secondary"
                    onClick={(e) =>
                        props.onPaginationUpdate({ ...props.pagination, currentPage: props.pagination.pages })
                    }
                >
                    <FontAwesomeIcon icon={faChevronsRight} />
                </Button>
            </div>
        );
    };

    // useEffect(() => {
    //     console.log(props.data);
    //     if (rendered) {
    //         const dataPerPage = props.pagination.dataPerPage;
    //         const pages = Math.ceil(props.data.length / dataPerPage);
    //         let currentPage = props.pagination.currentPage > pages ? pages : props.pagination.currentPage;

    //         if (currentPage <= 0) currentPage = 1;

    //         setPagination({
    //             dataPerPage: dataPerPage,
    //             pages: pages,
    //             currentPage: currentPage
    //         });
    //     }
    // }, [props.data]);

    return (
        <div
            className="userful-table-footer noselect"
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div className="userful-table-sub-footer ">
                {insertDropdown()}
                <p>
                    {(props.pagination.currentPage - 1) * props.pagination.dataPerPage + 1} -{" "}
                    {props.pagination.currentPage * props.pagination.dataPerPage > props.data.length
                        ? props.data.length
                        : props.pagination.currentPage * props.pagination.dataPerPage}{" "}
                    of {props.data.length}
                </p>
            </div>
            {insertPages()}
        </div>
    );
}
